(function () {
  /*
   * Persistent UI state keys.
   * These keys are used to restore the widget visual state
   * after PJAX navigation within the store.
   */
  var STORAGE_WIDGET_OPEN = "misglobos_widget_open";
  var STORAGE_WIDGET_MINIMIZED = "misglobos_widget_minimized";

  /*
   * Small DOM helper by id.
   */
  function $(id) {
    return document.getElementById(id);
  }

  /*
   * Returns the root widget element.
   */
  function getWidget() {
    return $("daily-widget");
  }

  /*
   * Reads the Daily room URL from the widget dataset.
   * Falls back to the current hardcoded room if the attribute is missing.
   */
  function getRoomUrl() {
    var widget = getWidget();
    var fromData = widget ? (widget.getAttribute("data-room-url") || "") : "";
    return (fromData || "https://misglobosonlive.daily.co/MisGlobosENVivo").toString().trim();
  }

  /*
   * Reads the Cloudflare Worker base URL from the widget dataset.
   * Falls back to the current hardcoded Worker URL if the attribute is missing.
   */
  function getGatekeeperBase() {
    var widget = getWidget();
    var fromData = widget ? (widget.getAttribute("data-gatekeeper") || "") : "";
    return (fromData || "https://misglobosenvivos.steep-moon-d562.workers.dev/").toString().trim();
  }

  /*
   * Resolves the operator waiting sound URL.
   * Supports:
   * - window.MISGLOBOS_WAITING_MP3
   * - widget data attribute
   * - protocol-relative URLs
   */
  function getOperatorWaitSoundUrl() {
    var widget = getWidget();
    var fromData = widget ? (widget.getAttribute("data-wait-sound") || "") : "";
    var url = (window.MISGLOBOS_WAITING_MP3 || fromData || "").toString().trim();

    if (url.indexOf("//") === 0) {
      url = "https:" + url;
    }

    return url;
  }

  function openScheduleModal() {
    var modal = $("daily-schedule-modal");
    if (!modal) return;

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
  }

  function closeScheduleModal() {
    var modal = $("daily-schedule-modal");
    if (!modal) return;

    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
  }

  function bindScheduleModal() {
    var modal = $("daily-schedule-modal");
    var closeBtn = $("daily-schedule-modal-close");
    var okBtn = $("daily-schedule-modal-ok");

    if (!modal) return;
    if (modal.getAttribute("data-daily-inited") === "1") return;

    modal.setAttribute("data-daily-inited", "1");

    function handleClose() {
      closeScheduleModal();
    }

    if (closeBtn) {
      closeBtn.addEventListener("click", handleClose);
    }

    if (okBtn) {
      okBtn.addEventListener("click", handleClose);
    }

    modal.addEventListener("click", function (e) {
      if (e.target === modal || e.target.classList.contains("daily-schedule-modal__backdrop")) {
        handleClose();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal.classList.contains("is-open")) {
        handleClose();
      }
    });
  }

  /*
   * Updates the widget status text.
   */
    function setStatus(msg) {
      var statusEl = $("daily-status");
      if (statusEl) statusEl.textContent = msg || "";
    }

  function getMadridWeekday() {
    try {
      var parts = new Intl.DateTimeFormat("en-GB", {
        timeZone: "Europe/Madrid",
        weekday: "short"
      }).formatToParts(new Date());

      var weekdayPart = parts.find(function (p) {
        return p.type === "weekday";
      });

      return weekdayPart ? weekdayPart.value : "";
    } catch (e) {
      var fallbackDay = new Date().getDay();
      return ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][fallbackDay] || "";
    }
  }

  function getMadridHour() {
    try {
      var parts = new Intl.DateTimeFormat("en-GB", {
        timeZone: "Europe/Madrid",
        hour: "2-digit",
        hour12: false
      }).formatToParts(new Date());

      var hourPart = parts.find(function (p) { return p.type === "hour"; });
      return hourPart ? parseInt(hourPart.value, 10) : new Date().getHours();
    } catch (e) {
      return new Date().getHours();
    }
  }

  function isVideoCallWithinSchedule() {
    var hour = getMadridHour();
    var weekday = getMadridWeekday();
    var isWeekend = weekday === "Sat" || weekday === "Sun";

    // Lunes a viernes, de 10:00 a 17:00 (hasta 16:59)
    return !isWeekend && hour >= 10 && hour < 17;
  }

  function getVideoCallClosedMessage() {
    return "La videollamada está disponible de lunes a viernes, de 10:00 a 17:00. Puedes escribirnos por WhatsApp o llamarnos.";
  }

  function syncVideoCallScheduleUi() {
    if (getRoleFromUrl() === "operator") return;

    var dailyBtn = $("daily-open-btn");
    var heroBtn = $("hero-video-call-btn");
    var open = isVideoCallWithinSchedule();

    if (dailyBtn) {
      dailyBtn.classList.toggle("is-out-of-hours", !open);
      dailyBtn.textContent = open ? "Videollamada" : "Videollamada";
    }

    if (heroBtn) {
      heroBtn.classList.toggle("is-out-of-hours", !open);
      heroBtn.setAttribute("aria-disabled", open ? "false" : "true");
    }
  }


  /*
   * Detects the role from the URL.
   * Operator mode is enabled with ?operador=1
   */
  function getRoleFromUrl() {
    try {
      var u = new URL(window.location.href);
      return u.searchParams.get("operador") === "1" ? "operator" : "customer";
    } catch (e) {
      return "customer";
    }
  }

  function isOperatorRole() {
    return getRoleFromUrl() === "operator";
  }

  /*
   * Lets the customer choose whether to join anonymously or with a name.
   */
  function chooseNameOrAnonymous() {
  return new Promise(function (resolve) {
    var modal = $("daily-name-modal");
    var closeBtn = $("daily-name-modal-close");
    var anonymousBtn = $("daily-name-anonymous-btn");
    var showInputBtn = $("daily-name-show-input-btn");
    var inputWrap = $("daily-name-input-wrap");
    var nameInput = $("daily-name-input");
    var confirmBtn = $("daily-name-confirm-btn");
    var cancelBtn = $("daily-name-cancel-btn");

    if (!modal) {
      resolve("");
      return;
    }

    function cleanup() {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");

      if (inputWrap) inputWrap.style.display = "none";
      if (nameInput) nameInput.value = "";

      anonymousBtn && anonymousBtn.removeEventListener("click", onAnonymous);
      showInputBtn && showInputBtn.removeEventListener("click", onShowInput);
      confirmBtn && confirmBtn.removeEventListener("click", onConfirmName);
      cancelBtn && cancelBtn.removeEventListener("click", onCancel);
      closeBtn && closeBtn.removeEventListener("click", onCancel);
      modal.removeEventListener("click", onBackdropClick);
      document.removeEventListener("keydown", onKeyDown);
    }

    function finish(value) {
      cleanup();
      resolve(value);
    }

    function onAnonymous() {
      finish("");
    }

    function onShowInput() {
      if (inputWrap) inputWrap.style.display = "block";
      if (nameInput) {
        nameInput.focus();
      }
    }

    function onConfirmName() {
      var name = nameInput ? nameInput.value : "";
      name = (name || "").trim();

      if (!name) {
        if (nameInput) nameInput.focus();
        return;
      }

      finish(name.slice(0, 60));
    }

    function onCancel() {
      finish("");
    }

    function onBackdropClick(e) {
      if (e.target === modal || e.target.classList.contains("daily-name-modal__backdrop")) {
        finish("");
      }
    }

    function onKeyDown(e) {
      if (e.key === "Escape") {
        finish("");
      }

      if (e.key === "Enter" && inputWrap && inputWrap.style.display === "block") {
        onConfirmName();
      }
    }

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");

    anonymousBtn && anonymousBtn.addEventListener("click", onAnonymous);
    showInputBtn && showInputBtn.addEventListener("click", onShowInput);
    confirmBtn && confirmBtn.addEventListener("click", onConfirmName);
    cancelBtn && cancelBtn.addEventListener("click", onCancel);
    closeBtn && closeBtn.addEventListener("click", onCancel);
    modal.addEventListener("click", onBackdropClick);
    document.addEventListener("keydown", onKeyDown);
  });
}

  /*
   * Prompts the operator for identity and passcode.
   * Values are cached in localStorage for convenience.
   */
  function askOperatorIdentity() {
    var savedName = localStorage.getItem("operator_name") || "";
    var savedPass = localStorage.getItem("operator_passcode") || "";

    var name = window.prompt("Nombre del operador:", savedName || "");
    if (!name) return null;

    var passcode = window.prompt("Passcode de operador:", savedPass || "");
    if (!passcode) return null;

    name = ("" + name).trim().slice(0, 60);
    passcode = ("" + passcode).trim();

    if (!name || !passcode) return null;

    localStorage.setItem("operator_name", name);
    localStorage.setItem("operator_passcode", passcode);

    return { name: name, passcode: passcode };
  }

  /*
   * Loads Daily JS only once.
   */
  function loadDaily() {
    return new Promise(function (resolve, reject) {
      if (window.DailyIframe) {
        resolve();
        return;
      }

      var existing = document.querySelector("script[data-daily-js]");
      if (existing) {
        existing.addEventListener("load", function () {
          resolve();
        }, { once: true });

        existing.addEventListener("error", function () {
          reject(new Error("No se pudo cargar daily-js"));
        }, { once: true });

        return;
      }

      var s = document.createElement("script");
      s.src = "https://unpkg.com/@daily-co/daily-js";
      s.async = true;
      s.setAttribute("data-daily-js", "1");

      s.onload = function () {
        resolve();
      };

      s.onerror = function () {
        reject(new Error("No se pudo cargar daily-js"));
      };

      document.head.appendChild(s);
    });
  }


  function cancelCustomerTicketOnUnload() {
    if (!customerTicketId) return;
    if (getRoleFromUrl() !== "customer") return;
    if (callFrame) return;

    try {
      var url = getGatekeeperBase() + "/customer/cancel";
      var payload = JSON.stringify({ ticketId: customerTicketId });

      if (navigator.sendBeacon) {
        var blob = new Blob([payload], { type: "application/json" });
        navigator.sendBeacon(url, blob);
        return;
      }

      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: payload,
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }

  function cancelCustomerTicket() {
    if (!customerTicketId) {
      return Promise.resolve();
    }

    if (getRoleFromUrl() !== "customer") {
      return Promise.resolve();
    }

    return postJson("/customer/cancel", {
      ticketId: customerTicketId
    }).then(function () {
      customerTicketId = null;
    }).catch(function () {
      customerTicketId = null;
    });
  }

  /*
   * Helper for POST JSON requests to the Worker.
   */
  function postJson(path, payload) {
    return fetch(getGatekeeperBase() + path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload || {})
    }).then(function (r) {
      return r.json().then(function (j) {
        return { status: r.status, json: j };
      });
    });
  }

  /*
   * Helper for GET JSON requests to the Worker.
   */
  function getJson(pathWithQuery) {
    return fetch(getGatekeeperBase() + pathWithQuery).then(function (r) {
      return r.json().then(function (j) {
        return { status: r.status, json: j };
      });
    });
  }

  /*
   * Runtime state.
   */
  var operatorWaitAudio = null;
  var callFrame = null;
  var isBusy = false;
  var timer = null;
  var customerFallbackTimer = null;
  var customerFallbackMenuTimer = null;
  var customerTicketId = null;
  var operatorActiveTicketId = null;
  var operatorCtx = null;
  var isLocalScreenSharing = false;

  /*
   * Creates or reuses the operator waiting sound instance.
   */
  function ensureOperatorAudio() {
    var url = getOperatorWaitSoundUrl();
    if (!url) return null;

    if (operatorWaitAudio && operatorWaitAudio.src && operatorWaitAudio.src.indexOf(url) !== -1) {
      return operatorWaitAudio;
    }

    try {
      if (operatorWaitAudio) {
        operatorWaitAudio.pause();
        operatorWaitAudio.currentTime = 0;
      }
    } catch (e) {}

    operatorWaitAudio = new Audio(url);
    operatorWaitAudio.loop = true;
    operatorWaitAudio.preload = "auto";
    operatorWaitAudio.volume = 1;
    return operatorWaitAudio;
  }

  /*
   * Starts the operator waiting loop sound.
   */
  function startOperatorWaitSound() {
    try {
      var a = ensureOperatorAudio();
      if (!a) return;

      var p = a.play();
      if (p && typeof p.catch === "function") {
        p.catch(function () {});
      }
    } catch (e) {}
  }

  /*
   * Stops the operator waiting sound.
   */
  function stopOperatorWaitSound() {
    try {
      if (!operatorWaitAudio) return;
      operatorWaitAudio.pause();
      operatorWaitAudio.currentTime = 0;
    } catch (e) {}
  }

  /*
   * Unlocks audio playback after a user gesture.
   * This helps with browser autoplay restrictions.
   */
  function unlockOperatorAudioOnUserGesture() {
    try {
      var a = ensureOperatorAudio();
      if (!a) return;

      a.muted = true;
      var p = a.play();

      if (p && typeof p.then === "function") {
        p.then(function () {
          try {
            a.pause();
            a.currentTime = 0;
            a.muted = false;
          } catch (e) {}
        }).catch(function () {});
      }
    } catch (e) {}
  }

  /*
   * Returns whether the local participant currently has video enabled.
   */
  function isLocalCameraEnabled() {
    if (!callFrame || typeof callFrame.participants !== "function") return false;

    try {
      var local = callFrame.participants().local || {};
      var video = local.media && local.media.video;

      return !!(video && (
        video.state === "playable" ||
        video.state === "loading" ||
        video.state === "interrupted"
      ));
    } catch (e) {
      return false;
    }
  }

  /*
   * Updates the camera button label and enabled/disabled state.
   */
  function updateCameraButton() {
    var camBtn = $("daily-camera-btn");
    if (!camBtn) return;

    if (!callFrame) {
      camBtn.disabled = true;
      camBtn.textContent = "Activar cámara";
      return;
    }

    camBtn.disabled = false;
    camBtn.textContent = isLocalCameraEnabled() ? "Desactivar cámara" : "Activar cámara";
  }

  /*
   * Updates the screen share button label and visibility.
   * Operators can always see the button when a call exists.
   */
  function updateShareButton() {
    var shareBtn = $("daily-share-btn");
    if (!shareBtn) return;

    if (!isOperatorRole()) {
      shareBtn.style.display = "none";
      shareBtn.disabled = true;
      return;
    }

    shareBtn.style.display = "inline-flex";
    shareBtn.disabled = !callFrame;
    shareBtn.textContent = isLocalScreenSharing ? "Dejar de compartir" : "Compartir pantalla";
  }

  /*
   * Resets button states to the initial inactive state.
   */
  function resetButtons() {
    var camBtn = $("daily-camera-btn");
    var hangupBtn = $("daily-hangup-btn");
    var shareBtn = $("daily-share-btn");

    if (camBtn) {
      camBtn.disabled = true;
      camBtn.textContent = "Activar cámara";
    }

    if (hangupBtn) hangupBtn.disabled = true;

    if (shareBtn) {
      shareBtn.disabled = true;
      shareBtn.textContent = "Compartir pantalla";
    }

    isLocalScreenSharing = false;
    updateShareButton();
  }

  /*
   * Synchronizes UI buttons with the current in-memory call state.
   * Useful after PJAX navigation, when the widget DOM survives but
   * the UI needs to be refreshed.
   */
  function syncButtonsWithState() {
    var hangupBtn = $("daily-hangup-btn");
    var shareBtn = $("daily-share-btn");

    if (callFrame) {
      updateCameraButton();

      if (hangupBtn) hangupBtn.disabled = false;

      if (shareBtn && isOperatorRole()) {
        shareBtn.style.display = "inline-flex";
        shareBtn.disabled = false;
      }

      updateShareButton();
      return;
    }

    resetButtons();
  }

  /*
   * Clears the generic retry timer.
   */
  function clearTimer() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  /*
   * Clears the customer fallback timer.
   */
  function clearCustomerFallbackTimer() {
    if (customerFallbackTimer) {
      clearTimeout(customerFallbackTimer);
      customerFallbackTimer = null;
    }
  }

  /*
   * Clears the customer fallback menu timer.
   */
  function clearCustomerFallbackMenuTimer() {
    if (customerFallbackMenuTimer) {
      clearTimeout(customerFallbackMenuTimer);
      customerFallbackMenuTimer = null;
    }
  }

  /*
   * Stops the customer waiting flow.
   */
  function stopCustomerWaiting(message) {
    clearTimer();
    clearCustomerFallbackTimer();
    clearCustomerFallbackMenuTimer();
    isBusy = false;

    if (message) {
      setStatus(message);
    }
  }

  /*
   * Hides the widget without destroying the current call state explicitly.
   * Also clears persisted UI state.
   */
  function hideDailyWidgetOnly() {
    var widget = $("daily-widget");
    if (widget) {
      widget.classList.remove("is-open");
      widget.classList.remove("is-minimized");
      widget.setAttribute("aria-hidden", "true");
    }

    document.body.classList.remove("misglobos-daily-open");
    sessionStorage.removeItem(STORAGE_WIDGET_OPEN);
    sessionStorage.removeItem(STORAGE_WIDGET_MINIMIZED);
  }

  /*
   * Opens the contact menu fallback when nobody answers in time.
   */
  function openContactMenuFallback() {
    cancelCustomerTicket().finally(function () {
      stopCustomerWaiting("Ahora mismo no podemos atender por videollamada. Puedes escribirnos por WhatsApp o llamarnos.");

      customerFallbackMenuTimer = setTimeout(function () {
        hideDailyWidgetOnly();
        var menu = $("contact-options");
        if (menu) {
          menu.classList.add("open");
        }
      }, 40000);
    });
  }

  /*
   * Starts the customer timeout that shows alternative contact methods.
   */
  function startCustomerFallbackTimer() {
    clearCustomerFallbackTimer();

    customerFallbackTimer = setTimeout(function () {
      if (!customerTicketId || callFrame) return;
      openContactMenuFallback();
    }, 60000);
  }

  /*
   * Attaches Daily event listeners for:
   * - customer auto hangup when operator leaves
   * - screen share state updates
   * - local participant media updates
   */
  function attachFrameEvents(role) {
    if (!callFrame || typeof callFrame.on !== "function") return;

    callFrame.on("participant-left", function (ev) {
      try {
        if (role !== "customer") return;
        if (!ev || !ev.participant) return;
        if (ev.participant.local) return;

        setStatus("El operador ha salido de la llamada.");
        hangUp(false);
      } catch (e) {}
    });

    callFrame.on("participant-updated", function (ev) {
      try {
        if (!ev || !ev.participant || !ev.participant.local) return;
        updateCameraButton();
        updateShareButton();
      } catch (e) {}
    });

    callFrame.on("local-screen-share-started", function () {
      isLocalScreenSharing = true;
      updateShareButton();
      setStatus("Pantalla compartida.");
    });

    callFrame.on("local-screen-share-stopped", function () {
      isLocalScreenSharing = false;
      updateShareButton();
      setStatus("Has dejado de compartir pantalla.");
    });

    callFrame.on("screen-share-error", function (ev) {
      isLocalScreenSharing = false;
      updateShareButton();
      try { console.error("screen-share-error", ev); } catch (e) {}
      setStatus("No se pudo compartir pantalla.");
    });
  }

  /*
   * Destroys the Daily call instance safely.
   * Includes:
   * - optional screen share stop
   * - leave()
   * - destroy()
   * - timeout fallback in case Daily hangs
   */
  function destroyCall() {
    return new Promise(function (resolve) {
      var container = $("daily-container");
      var finished = false;

      function finish() {
        if (finished) return;
        finished = true;

        try {
          if (callFrame) {
            callFrame.destroy();
          }
        } catch (e) {}

        callFrame = null;
        isLocalScreenSharing = false;

        if (container) {
          container.innerHTML = "";
        }

        resetButtons();
        resolve();
      }

      clearTimer();
      clearCustomerFallbackTimer();
      clearCustomerFallbackMenuTimer();
      isBusy = false;

      if (!callFrame) {
        finish();
        return;
      }

      var safetyTimer = setTimeout(function () {
        finish();
      }, 2500);

      function safeFinish() {
        clearTimeout(safetyTimer);
        finish();
      }

      try {
        var stopSharePromise = null;

        if (isLocalScreenSharing && typeof callFrame.stopScreenShare === "function") {
          try {
            stopSharePromise = callFrame.stopScreenShare();
          } catch (e) {}
        }

        Promise.resolve(stopSharePromise)
          .catch(function () {})
          .then(function () {
            try {
              var leavePromise = callFrame.leave();

              if (leavePromise && typeof leavePromise.then === "function") {
                leavePromise.then(function () {
                  safeFinish();
                }).catch(function () {
                  safeFinish();
                });
              } else {
                safeFinish();
              }
            } catch (e) {
              safeFinish();
            }
          });
      } catch (e) {
        safeFinish();
      }
    });
  }

  /*
   * Closes the widget completely, including the current call.
   */
  function closeWidget() {
    var isCustomerWaiting =
      getRoleFromUrl() === "customer" &&
      !!customerTicketId &&
      !callFrame;

    var cancelPromise = isCustomerWaiting
      ? cancelCustomerTicket()
      : Promise.resolve();

    return cancelPromise.then(function () {
      return hangUp(true);
    }).then(function () {
      var widget = $("daily-widget");
      if (widget) {
        widget.classList.remove("is-open");
        widget.classList.remove("is-minimized");
        widget.setAttribute("aria-hidden", "true");
      }

      document.body.classList.remove("misglobos-daily-open");
      sessionStorage.removeItem(STORAGE_WIDGET_OPEN);
      sessionStorage.removeItem(STORAGE_WIDGET_MINIMIZED);
      setStatus("");
    });
  }

  /*
   * Toggles widget minimized state and persists it.
   */
  function toggleMinimize() {
    var widget = getWidget();
    if (!widget) return;

    if (widget.classList.contains("is-minimized")) {
      widget.classList.remove("is-minimized");
      sessionStorage.removeItem(STORAGE_WIDGET_MINIMIZED);
    } else {
      widget.classList.add("is-minimized");
      sessionStorage.setItem(STORAGE_WIDGET_MINIMIZED, "1");
    }
  }

  /*
   * Opens the widget visually and persists that UI state.
   */
  function openWidgetOnly() {
    var widget = $("daily-widget");
    if (!widget) return;

    widget.classList.add("is-open");
    widget.setAttribute("aria-hidden", "false");
    document.body.classList.add("misglobos-daily-open");
    sessionStorage.setItem(STORAGE_WIDGET_OPEN, "1");
  }

  /*
   * Restores visual widget state after PJAX navigation.
   */
  function restoreWidgetUiState() {
    var widget = $("daily-widget");
    if (!widget) return;

    if (sessionStorage.getItem(STORAGE_WIDGET_OPEN) === "1") {
      widget.classList.add("is-open");
      widget.setAttribute("aria-hidden", "false");
      document.body.classList.add("misglobos-daily-open");
    }

    if (sessionStorage.getItem(STORAGE_WIDGET_MINIMIZED) === "1") {
      widget.classList.add("is-minimized");
    } else {
      widget.classList.remove("is-minimized");
    }
  }

  /*
   * Creates the Daily frame and joins the call with a token.
   */
  function joinDailyWithToken(token) {
    return loadDaily().then(function () {
      var container = $("daily-container");
      if (!container) throw new Error("No daily-container");

      callFrame = window.DailyIframe.createFrame(container, {
        showLeaveButton: false,
        showFullscreenButton: false,
        iframeStyle: {
          width: "100%",
          height: "100%",
          border: "0",
          display: "block"
        }
      });

      attachFrameEvents(getRoleFromUrl());

      return callFrame.join({
        url: getRoomUrl(),
        token: token,
        startVideoOff: true,
        startAudioOff: false
      });
    }).then(function () {
      setStatus("Conectado. Micrófono activo. Cámara apagada.");

      isLocalScreenSharing = false;
      updateCameraButton();
      updateShareButton();
      syncButtonsWithState();
    });
  }

  /*
   * Creates a customer ticket in the Worker queue.
   */
  function customerRequestTicket(userName) {
    return postJson("/request", { userName: userName || "Cliente" });
  }

  /*
   * Polls the current customer ticket until:
   * - a token is received
   * - the ticket expires
   * - the ticket is closed
   */
  function customerPollTicket() {
    if (!customerTicketId) return;

    getJson("/ticket?id=" + encodeURIComponent(customerTicketId))
      .then(function (res) {
        var data = res.json || {};

        if (data.ok && data.action === "join" && data.token) {
          clearTimer();
          clearCustomerFallbackTimer();
          isBusy = false;
          setStatus("Experto disponible. Entrando a la llamada...");

          return joinDailyWithToken(data.token).catch(function (e) {
            try { console.error(e); } catch {}
            setStatus("Error al iniciar la llamada.");
          });
        }

        if (data.action === "expired") {
          clearTimer();
          clearCustomerFallbackTimer();
          isBusy = false;
          customerTicketId = null;
          setStatus(data.message || "La solicitud ha caducado.");
          return;
        }

        if (data.action === "closed") {
          clearTimer();
          clearCustomerFallbackTimer();
          isBusy = false;
          customerTicketId = null;
          setStatus(data.message || "La sesión se cerró.");
          return;
        }

        setStatus(data.message || "Esperando a un experto...");
        timer = setTimeout(customerPollTicket, 3000);
      })
      .catch(function (e) {
        try { console.error(e); } catch {}
        setStatus("No se pudo consultar la cola. Reintentando...");
        timer = setTimeout(customerPollTicket, 3000);
      });
  }

  /*
   * Starts the customer-side flow:
   * - asks for name
   * - creates ticket
   * - starts fallback timer
   * - starts polling
   */
  function startCustomerFlow() {
    if (!isVideoCallWithinSchedule()) {
      isBusy = false;
      setStatus(getVideoCallClosedMessage());

      var menu = $("contact-options");
      if (menu) {
        menu.classList.add("open");
      }

      return;
    }

    if (isBusy) return;
    isBusy = true;

    chooseNameOrAnonymous().then(function (userName) {
      if (!userName) userName = "Cliente";

      setStatus("Creando solicitud...");

      return customerRequestTicket(userName).then(function (res) {
        var data = res.json || {};
        if (!data.ok || !data.ticketId) {
          isBusy = false;
          setStatus(data.message || data.error || "No se pudo crear la solicitud.");
          return;
        }

        customerTicketId = data.ticketId;
        setStatus(data.message || "Esperando a un experto...");
        startCustomerFallbackTimer();
        timer = setTimeout(customerPollTicket, 3000);
        isBusy = false;
      });
    }).catch(function (e) {
      try { console.error(e); } catch {}
      isBusy = false;
      setStatus("No se pudo conectar con el servidor.");
    });
  }

  /*
   * Asks the Worker whether there is a customer waiting.
   */
  function operatorNext() {
    if (!operatorCtx) {
      return Promise.resolve({ json: { ok: false, error: "No operatorCtx" } });
    }

    return postJson("/operator/next", { passcode: operatorCtx.passcode });
  }

  /*
   * Accepts the next waiting customer and requests the operator token.
   */
  function operatorAccept() {
    if (!operatorCtx) {
      return Promise.resolve({ json: { ok: false, error: "No operatorCtx" } });
    }

    return postJson("/operator/accept", {
      passcode: operatorCtx.passcode,
      operatorName: operatorCtx.name
    });
  }

  /*
   * Main operator polling loop.
   * Checks the queue regularly and asks the operator whether to accept the call.
   */
  function operatorLoop() {
    if (!operatorCtx) return;
    if (callFrame) return;

    operatorNext().then(function (res) {
      var data = res.json || {};

      if (!data.ok) {
        stopOperatorWaitSound();
        setStatus(data.error || "No autorizado como operador.");
        timer = setTimeout(operatorLoop, 3000);
        return;
      }

      if (data.action === "busy") {
        stopOperatorWaitSound();
        setStatus(data.message || "Llamada activa.");
        timer = setTimeout(operatorLoop, 3000);
        return;
      }

      if (data.action === "none") {
        stopOperatorWaitSound();
        setStatus(data.message || "No hay clientes esperando.");
        timer = setTimeout(operatorLoop, 3000);
        return;
      }

      if (data.action === "has_customer") {
        startOperatorWaitSound();

        var ok = window.confirm(
          "Hay un cliente esperando: " + (data.customerName || "Cliente") + "\n\n¿Aceptar y entrar en llamada?"
        );

        if (!ok) {
          stopOperatorWaitSound();
          setStatus("Has pospuesto la llamada. Revisando cola...");
          timer = setTimeout(operatorLoop, 3000);
          return;
        }

        stopOperatorWaitSound();
        setStatus("Aceptando cliente...");

        operatorAccept().then(function (res2) {
          var d2 = res2.json || {};

          if (!d2.ok || d2.action !== "join" || !d2.token) {
            stopOperatorWaitSound();
            setStatus(d2.message || d2.error || "No se pudo aceptar al cliente.");
            timer = setTimeout(operatorLoop, 3000);
            return;
          }

          operatorActiveTicketId = d2.ticketId || null;
          setStatus("Entrando a la llamada...");

          joinDailyWithToken(d2.token).catch(function (e) {
            try { console.error(e); } catch {}
            setStatus("Error al iniciar la llamada.");
          });
        }).catch(function (e) {
          stopOperatorWaitSound();
          try { console.error(e); } catch {}
          setStatus("No se pudo aceptar. Reintentando...");
          timer = setTimeout(operatorLoop, 3000);
        });

        return;
      }

      stopOperatorWaitSound();
      setStatus("Estado desconocido. Reintentando...");
      timer = setTimeout(operatorLoop, 3000);
    }).catch(function (e) {
      stopOperatorWaitSound();
      try { console.error(e); } catch {}
      setStatus("No se pudo consultar cola. Reintentando...");
      timer = setTimeout(operatorLoop, 3000);
    });
  }

  /*
   * Starts operator mode.
   */
  function startOperatorFlow() {
    if (isBusy) return;
    isBusy = true;

    var op = askOperatorIdentity();
    if (!op) {
      isBusy = false;
      setStatus("Cancelado. No has entrado como operador.");
      return;
    }

    operatorCtx = { name: op.name, passcode: op.passcode };
    unlockOperatorAudioOnUserGesture();
    updateShareButton();

    var resetBtn = $("operator-reset-btn");
    if (resetBtn) {
      resetBtn.style.display = "inline-flex";
    }

    setStatus("Modo operador. Esperando clientes...");

    clearTimer();
    timer = setTimeout(operatorLoop, 0);

    isBusy = false;
  }

  /*
   * Opens the widget and starts the correct flow according to the current role.
   */
  function openWidgetAndStartFlow() {
    if (getRoleFromUrl() === "customer" && !isVideoCallWithinSchedule()) {
      openScheduleModal();
      return;
    }

    openWidgetOnly();

    if (callFrame) {
      setStatus("Ya estás en la llamada.");
      return;
    }

    clearTimer();

    if (getRoleFromUrl() === "customer") {
      startCustomerFlow();
      return;
    }

    startOperatorFlow();
  }

  /*
   * Toggles local camera state and updates the button label accordingly.
   */
  function toggleCamera() {
    if (!callFrame) return;

    var nextState = !isLocalCameraEnabled();

    try {
      var p = callFrame.setLocalVideo(nextState);

      if (p && typeof p.then === "function") {
        p.then(function () {
          updateCameraButton();
          setStatus(nextState ? "Cámara activada." : "Cámara desactivada.");
        }).catch(function () {
          updateCameraButton();
          setStatus(nextState ? "No se pudo activar la cámara." : "No se pudo desactivar la cámara.");
        });
      } else {
        updateCameraButton();
        setStatus(nextState ? "Cámara activada." : "Cámara desactivada.");
      }
    } catch (e) {
      updateCameraButton();
      setStatus(nextState ? "No se pudo activar la cámara." : "No se pudo desactivar la cámara.");
    }
  }

  /*
   * Toggles screen sharing for operators.
   */
  function toggleScreenShare() {
    if (!isOperatorRole()) {
      setStatus("Solo el operador puede compartir pantalla.");
      return;
    }

    if (!callFrame) {
      setStatus("Primero debes entrar en la llamada.");
      return;
    }

    var shareBtn = $("daily-share-btn");
    if (shareBtn) shareBtn.disabled = true;

    try {
      var result;

      if (isLocalScreenSharing) {
        result = callFrame.stopScreenShare();
      } else {
        setStatus("Abriendo selector para compartir pantalla...");
        result = callFrame.startScreenShare();
      }

      if (result && typeof result.then === "function") {
        result.then(function () {
          updateShareButton();
          syncButtonsWithState();
        }).catch(function (e) {
          isLocalScreenSharing = false;
          updateShareButton();
          syncButtonsWithState();
          try { console.error(e); } catch {}
          setStatus("No se pudo compartir pantalla.");
        });
      } else {
        updateShareButton();
        syncButtonsWithState();
      }
    } catch (e) {
      isLocalScreenSharing = false;
      updateShareButton();
      syncButtonsWithState();
      try { console.error(e); } catch {}
      setStatus("No se pudo compartir pantalla.");
    }
  }

  /*
   * Ends the current call and notifies the Worker if needed.
   */
  function hangUp(isClosingWidget) {
    stopOperatorWaitSound();
    clearCustomerFallbackTimer();
    clearCustomerFallbackMenuTimer();
    setStatus("Colgando...");

    var role = getRoleFromUrl();
    var hangupBtn = $("daily-hangup-btn");
    if (hangupBtn) {
      hangupBtn.disabled = true;
    }

    return destroyCall().then(function () {
      if (role === "operator" && operatorCtx && operatorActiveTicketId) {
        return postJson("/operator/close", {
          passcode: operatorCtx.passcode,
          ticketId: operatorActiveTicketId
        }).then(function () {
          operatorActiveTicketId = null;

          if (!isClosingWidget) {
            setStatus("Llamada finalizada. Esperando nuevos clientes...");
            clearTimer();
            timer = setTimeout(operatorLoop, 3000);
          } else {
            setStatus("Llamada finalizada.");
          }
        }).catch(function () {
          operatorActiveTicketId = null;

          if (!isClosingWidget) {
            setStatus("Llamada finalizada. Esperando nuevos clientes...");
            clearTimer();
            timer = setTimeout(operatorLoop, 3000);
          } else {
            setStatus("Llamada finalizada.");
          }
        });
      }

      if (role === "customer") {
        customerTicketId = null;
      }

      if (!isClosingWidget) {
        setStatus("Llamada finalizada.");
      }
    }).catch(function () {
      setStatus("No se pudo cerrar la llamada correctamente.");
    });
  }

  /*
   * Calls the Worker emergency reset endpoint.
   */
  function resetActiveCall() {
    var passcode = localStorage.getItem("operator_passcode") || "";
    if (!passcode) {
      setStatus("No se encontró passcode de operador.");
      return;
    }

    setStatus("Reseteando estado de llamada...");

    postJson("/operator/reset", {
      passcode: passcode
    }).then(function (res) {
      var data = res.json || {};
      if (!data.ok) {
        setStatus(data.error || "No se pudo resetear.");
        return;
      }

      setStatus("Estado reseteado correctamente.");
    }).catch(function () {
      setStatus("Error al resetear el estado.");
    });
  }

  /*
   * Binds the floating contact menu interactions.
   */
  function bindMenu() {
    var menuBtn = $("contact-menu-btn");
    var menu = $("contact-options");
    var waBtn = $("contact-whatsapp-btn");
    var dailyBtn = $("daily-open-btn");
    var phoneBtn = $("contact-phone-btn");

    if (menuBtn && menu && !menuBtn.getAttribute("data-menu-inited")) {
      menuBtn.setAttribute("data-menu-inited", "1");

      menuBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        menu.classList.toggle("open");
      });

      document.addEventListener("click", function (e) {
        if (!menu.contains(e.target) && e.target !== menuBtn) {
          menu.classList.remove("open");
        }
      });
    }

    if (waBtn && !waBtn.getAttribute("data-menu-inited")) {
      waBtn.setAttribute("data-menu-inited", "1");
      waBtn.addEventListener("click", function () {
        stopCustomerWaiting("Te estamos redirigiendo a WhatsApp.");
        if (menu) menu.classList.remove("open");
      });
    }

    if (dailyBtn && !dailyBtn.getAttribute("data-menu-inited")) {
      dailyBtn.setAttribute("data-menu-inited", "1");
      dailyBtn.addEventListener("click", function () {
        if (menu) menu.classList.remove("open");
      });
    }

    if (phoneBtn && !phoneBtn.getAttribute("data-menu-inited")) {
      phoneBtn.setAttribute("data-menu-inited", "1");
      phoneBtn.addEventListener("click", function () {
        stopCustomerWaiting("Te estamos redirigiendo a llamada.");
        if (menu) menu.classList.remove("open");
      });
    }
  }

  function bindHeroVideoCallButton() {
  var heroBtn = $("hero-video-call-btn");
  if (!heroBtn) return;

  if (heroBtn.getAttribute("data-daily-inited") === "1") return;
  heroBtn.setAttribute("data-daily-inited", "1");

  heroBtn.addEventListener("click", function (e) {
    e.preventDefault();

    var menu = $("contact-options");
    if (menu) {
      menu.classList.remove("open");
    }

    openWidgetAndStartFlow();
  });
}

  function syncContactMenuVisibility() {
    var contactMenu = $("contact-menu");
    var contactOptions = $("contact-options");
    var widget = $("daily-widget");

    if (!contactMenu) return;

    var path = (window.location.pathname || "").toLowerCase();
    var isHiddenPage =
      path === "/pages/catalogo-empresas" ||
      path === "/pages/franquiciate";

    if (isHiddenPage) {
      contactMenu.style.display = "none";

      if (contactOptions) {
        contactOptions.classList.remove("open");
        contactOptions.classList.remove("is-collection-left");
      }

      if (widget) {
        widget.classList.remove("is-collection-left");
      }

      contactMenu.classList.remove("is-collection-left");
      return;
    }

    contactMenu.style.display = "";

    if (contactOptions) {
      contactOptions.classList.remove("is-collection-left");
    }

    if (widget) {
      widget.classList.remove("is-collection-left");
    }

    contactMenu.classList.remove("is-collection-left");
  }


  /*
   * Main initializer.
   * This is safe to call multiple times because listeners are guarded
   * with data-daily-inited / data-menu-inited attributes.
   */
  function init() {
    var openBtn = $("daily-open-btn");
    var joinBtn = $("daily-join-btn");
    var closeBtn = $("daily-close-btn");
    var minimizeBtn = $("daily-minimize-btn");
    var camBtn = $("daily-camera-btn");
    var hangupBtn = $("daily-hangup-btn");
    var shareBtn = $("daily-share-btn");
    var resetBtn = $("operator-reset-btn");
    var hasOperatorPass = !!localStorage.getItem("operator_passcode");

    if (!openBtn || !getWidget()) return;

    restoreWidgetUiState();

    if (!openBtn.getAttribute("data-daily-inited")) {
      openBtn.setAttribute("data-daily-inited", "1");
      openBtn.addEventListener("click", openWidgetAndStartFlow);
    }

    if (joinBtn && !joinBtn.getAttribute("data-daily-inited")) {
      joinBtn.setAttribute("data-daily-inited", "1");
      joinBtn.addEventListener("click", openWidgetAndStartFlow);
    }

    if (closeBtn && !closeBtn.getAttribute("data-daily-inited")) {
      closeBtn.setAttribute("data-daily-inited", "1");
      closeBtn.addEventListener("click", function () {
        closeWidget();
      });
    }

    if (minimizeBtn && !minimizeBtn.getAttribute("data-daily-inited")) {
      minimizeBtn.setAttribute("data-daily-inited", "1");
      minimizeBtn.addEventListener("click", toggleMinimize);
    }

    if (camBtn && !camBtn.getAttribute("data-daily-inited")) {
      camBtn.setAttribute("data-daily-inited", "1");
      camBtn.addEventListener("click", toggleCamera);
    }

    if (hangupBtn && !hangupBtn.getAttribute("data-daily-inited")) {
      hangupBtn.setAttribute("data-daily-inited", "1");
      hangupBtn.addEventListener("click", function () {
        hangUp(false);
      });
    }

    if (shareBtn && !shareBtn.getAttribute("data-daily-inited")) {
      shareBtn.setAttribute("data-daily-inited", "1");
      shareBtn.addEventListener("click", toggleScreenShare);
    }

    if (resetBtn && isOperatorRole() && hasOperatorPass) {
      resetBtn.style.display = "inline-flex";
    }

    if (resetBtn && !resetBtn.getAttribute("data-daily-inited")) {
      resetBtn.setAttribute("data-daily-inited", "1");
      resetBtn.addEventListener("click", resetActiveCall);
    }

    updateCameraButton();
    updateShareButton();
    syncButtonsWithState();
    bindMenu();
    bindHeroVideoCallButton();
    syncContactMenuVisibility();
    syncVideoCallScheduleUi();
    bindScheduleModal();
  }

  /*
   * Standard page load + PJAX page changes.
   */
  document.addEventListener("DOMContentLoaded", init);
  // document.addEventListener("pjax:load", init);
  window.addEventListener("pagehide", cancelCustomerTicketOnUnload);
  window.addEventListener("beforeunload", cancelCustomerTicketOnUnload);
})();

